import { css } from '@emotion/react'

const agentTypeDescription = css`
  display: block;
  margin: 4px 0px 10px 0;
`

export const styles = {
  agentTypeDescription,
}
